import React from 'react';

// Store data that can come from top level page but its used on single tile
const CollectionModalContext = React.createContext({
  isInModal: false,
});

export default CollectionModalContext;
